import { Divider, Grid, Stack, Typography } from "@mui/material";
import type { InvestorCommunicationInfo } from "../../api/types/investorCommunicationsTypes";
import NewsHeroCard from "./NewsHeroCard";
import NewsItemSummary from "./NewsItemSummary";
import { LATEST_NEWS_COUNT } from "./newsPageState";

interface Props {
  items: InvestorCommunicationInfo[];
  isFirstPage: boolean;
  newsPagePath: string;
}

const NewsList = ({ items, isFirstPage, newsPagePath }: Props) => {
  const latestItems = isFirstPage ? items.slice(0, LATEST_NEWS_COUNT) : [];
  const otherItems = isFirstPage ? items.slice(LATEST_NEWS_COUNT) : items;

  return (
    <Stack spacing={3}>
      {latestItems.length > 0 && (
        <>
          <Typography variant="h4">Latest</Typography>
          <Grid container spacing={3}>
            {latestItems.map((item) => (
              <Grid key={item.id} size={{ xs: 12, lg: 6 }}>
                <NewsHeroCard item={item} to={`${newsPagePath}/${item.id}`} />
              </Grid>
            ))}
          </Grid>
        </>
      )}
      {otherItems.length > 0 && (
        <>
          {isFirstPage && (
            <Typography variant="h4" sx={{ pt: 2 }}>
              Earlier
            </Typography>
          )}
          <Stack spacing={3} divider={<Divider />}>
            {otherItems.map((item) => (
              <NewsItemSummary key={item.id} item={item} to={`${newsPagePath}/${item.id}`} />
            ))}
          </Stack>
        </>
      )}
    </Stack>
  );
};

export default NewsList;
